module.exports = __webpack_public_path__ + "img/two.bdf045b9.png";